import { useState } from "react";

const links = [
  { href: "#hero", label: "Home" },
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  // { href: "#clients", label: "Clients" },
  { href: "#team", label: "Team" },
  // { href: "#blog", label: "Blog" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar({ scrolled }) {
  const [open, setOpen] = useState(false);

  const handleClick = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) {
      window.scrollTo({ top: el.offsetTop - 70, behavior: "smooth" });
    }
  };

  return (
    <header className={`site-nav ${scrolled ? "site-nav--scrolled" : ""}`}>
      <div className="site-nav__inner">
        <a href="#hero" className="site-nav__brand" onClick={(e) => handleClick(e, "#hero")}>
          <img src="assets/imgs/Dinghy.png" alt="Dinghy" />
          <span>Dinghy<span className="site-nav__brand-accent">.e2e</span></span>
        </a>

        <button
          className="site-nav__toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span className={`mdi ${open ? "mdi-close" : "mdi-menu"}`} />
        </button>

        <nav className={`site-nav__links ${open ? "site-nav__links--open" : ""}`}>
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={(e) => handleClick(e, l.href)}>
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            className="site-nav__cta"
            onClick={(e) => handleClick(e, "#contact")}
          >
            Let's Talk
          </a>
        </nav>
      </div>
    </header>
  );
}
